module.exports = __webpack_public_path__ + "static/media/training-center.dd90bad1.png";